export const QUALIFYING_SUBJECTS_STEP_ID = "qualifying-subjects";
export const QUALIFYING_SUBJECTS_STEP_TITLE = "Qualifying Subjects";
